import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    /* background-color: #f8f9fa; */
    background-color: transparent;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
  }

  * {
    box-sizing: border-box;
  }

  #root {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 20px;
  }

  h1, h2, h3, h4, h5, h6 {
    color: #00608a;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: center;
  }

  p {
    color: #6c757d;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 20px;
  }

  input, select, textarea {
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 16px;
    padding: 10px;
    width: 100%;
    margin-bottom: 20px;
  }

  button {
    background-color: #00cfd4;
    border: none;
    border-radius: 20px;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    padding: 10px 20px;
    transition: all 0.3s ease;

    &:hover {
      background-color: #00bfc4;
    }

    &[disabled] {
      background-color: #e9ecef;
      color: #6c757d;
      cursor: not-allowed;
    }
  }

  button.secondary {
    background-color: #fff;
    border: 1px solid #6c757d;
    color: #6c757d;

    &:hover {
      background-color: #f8f9fa;
    }
  }

  .container {
    max-width: 1000px;
    width: 100%;
    margin: 40px auto;
    padding: 30px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  .calendar-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .calendar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 800px;
    margin: 20px auto;
  }

  .day {
    padding: 10px;
    background-color: #f1f1f1;
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.3s ease;
    width: 100px;
  }

  .day.selected {
    background-color: #00cfd4;
    color: #fff;
  }

  .day:hover {
    background-color: #00bfc4;
    color: #fff;
  }

  .button-group {
    display: flex;
    justify-content: center;
    gap: 20px;
  }

  .doctor-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .doctor-info img {
    border-radius: 50%;
    margin-right: 15px;
  }

  .time-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
  }

  .time-buttons .btn-hora {
    padding: 10px 15px;
    border-radius: 4px;
    background-color: #e7f9fc;
    color: #00608a;
    border: none;
    cursor: pointer;
  }

  .btn-hora.active {
    background-color: #00cfd4;
    color: #fff;
  }

  .btn-hora.disabled {
    background-color: #ced4da;
    color: #6c757d;
    cursor: not-allowed;
  }

.label-text {
    color: #00547F;
  }

.label-textO {
    color: #00547F;
  }
    
.input-border {
    border: 2px solid #336699 !important; 
    transition: border-color 0.3s ease; 
    background-color: white; 
}

.input-border:focus {
    border-color: #00CFD4 !important; 
    outline: none; 
}

  .line-divider {
    border: none;
    border-top: 2px solid #CCCCCC;
    margin: 10px 0;
  }

  .inactive {
      pointer-events: none; /* Desactiva clics */
      opacity: 0.5; /* Reduce la opacidad */
      cursor: not-allowed; /* Cambia el cursor a "no permitido" */
  }
`;
export default GlobalStyle;